// extracted by mini-css-extract-plugin
module.exports = {"top":"_1r7WJ9ikpw","form-price":"_3UnhXEdlQM","width-160":"_9dwrIK5URR","content":"_3-IJ-UGS5Q","sort":"_32HketRMAl","list-img":"_3bqz08DLYK"};